import React,{useState} from 'react';
import { useTranslation } from 'react-i18next';
import { completeTask } from '../../../api/APIServices';
import { useDispatch } from 'react-redux';

import { Button, Card, CardActions, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import play from '../../../assets/images/play.jpg';
import no_image from '../../../assets/images/no_image.jpg';

function Video({task}) {
    const dispatch = useDispatch();
    const {t} = useTranslation('global');
    const [open, setOpen] = useState(false);
   
    const handleClickOpen = () => {
        setOpen(true);
    }
       
    const markAsComplete = () => {
        dispatch(completeTask({taskId:task.taskId}));
        setOpen(false);
    }
    
    const getThumnail = (type) => {
        switch(type){
            case 'video' :
              return play
            default: 
            return no_image
        }
      }
    
      const handleClose = () => {
        setOpen(false);
    };


  return (
        <div style={{width:'290px'}}>           
            <Card onClick={()=>handleClickOpen()}  size='small' sx={{margin:1}}>
               <CardMedia
                    component="img"
                    alt={task.type}
                    image={getThumnail(task.type)}
                />
                <CardActions sx={{paddingBottom:0,  backgroundColor: '#015681', color:'white', justifyContent:'center'}}>
                    <Typography>{task.type}</Typography>
                </CardActions>
            </Card>
    
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t("Playing Introduction Video")}
                </DialogTitle>
                <DialogContent>
                <CardMedia
                        component='video'
                        image={task.videoUrl}
                        controls
                        width={210}
                        height={380}
                />
                </DialogContent>
                <DialogActions>
                    <Button color='primary' size='small' 
                        variant="contained"  
                        onClick={handleClose} autoFocus>
                        {t('close')}
                    </Button>
                    <Button color='primary'  size='small' variant="outlined" 
                    onClick={() => markAsComplete()} autoFocus>
                        {t('mark_as_complete')}
                    </Button>
                </DialogActions>
            </Dialog>        
        </div>

  )
}


export default Video